import { UnauthenticatedTemplate } from '@azure/msal-react';
import { Container } from 'react-bootstrap';

/***
 * Component to confirm authentication
 */
export const Contact = () => {

    return (
        <>
            <UnauthenticatedTemplate>
                
                <Container>
                    <p>Componente com Contato</p>
                </Container>

            </UnauthenticatedTemplate>
        </>
    );
};